var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
var SoundOn36 = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentcolor' : _b, _c = _a.height, height = _c === void 0 ? '36px' : _c, _d = _a.width, width = _d === void 0 ? '36px' : _d, rest = __rest(_a, ["color", "height", "width"]);
    var svgStyle = __assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" }, { fill: color });
    return (React.createElement("div", __assign({ style: __assign({ "position": "relative" }, { height: height, width: width }) }, rest),
        React.createElement("svg", { viewBox: "0 0 36 36", fill: "none", style: svgStyle },
            React.createElement("circle", { cx: 18, cy: 18, r: 18, fillOpacity: 0.7 }),
            React.createElement("path", { d: "M7.875 13.7392V21.5109H11.3424L18.337 27.2501V8L11.3424 13.7392H7.875Z", fill: "white" }),
            React.createElement("path", { d: "M23.3344 9L22.5223 9.87227C24.718 11.9477 25.9211 14.6848 25.9211 17.5723C25.9211 20.4598 24.718 23.1969 22.4922 25.2422L23.3043 26.1145C25.7707 23.8586 27.1242 20.8207 27.1242 17.5723C27.1242 14.3238 25.7707 11.2859 23.3344 9Z", fill: "white" }),
            React.createElement("path", { d: "M21.8305 11.707L21.0184 12.5793C22.432 13.9328 23.2141 15.7074 23.2141 17.5723C23.2141 19.4371 22.432 21.2117 20.9883 22.5352L21.8004 23.4074C23.4848 21.8735 24.4172 19.7981 24.4172 17.5723C24.4172 15.3465 23.4848 13.2711 21.8305 11.707Z", fill: "white" }),
            React.createElement("path", { d: "M20.3273 14.4443L19.4551 15.2865C20.6582 16.5498 20.6582 18.5951 19.4551 19.8584L20.3273 20.7006C21.9816 18.9861 21.9816 16.1588 20.3273 14.4443Z", fill: "white" }))));
};
SoundOn36.displayName = 'SoundOn36';
export default SoundOn36;
//# sourceMappingURL=sound-on-36.js.map